import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ rawMaterialParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `RawMaterial/GetSearched`,
      params: rawMaterialParams,
    });
    const allRawMaterial = data;
    yield put(Actions.setAll({ allRawMaterial }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateRawMaterial({ rawMaterialData, actionName, rawMaterialParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `RawMaterial`,
      data: rawMaterialData,
    });
    yield put(Actions.fetchAll({ rawMaterialParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.RAW_MATERIAL_CREATED
        : CONSTANT_VARIABLES.RAW_MATERIAL_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteRawMaterial({ id, rawMaterialParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `RawMaterial/${id}`,
    });
    yield put(Actions.fetchAll({ rawMaterialParams }));
    notification('success', CONSTANT_VARIABLES.RAW_MATERIAL_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.ADD_OR_UPDATE_RAW_MATERIAL, addorUpdateRawMaterial),
    takeLatest(ActionTypes.DELETE_RAW_MATERIAL, deleteRawMaterial),
  ]);
}
